import { createAsyncThunk } from '@reduxjs/toolkit';
import AspApi from 'api/ApiConfig';

const BASE_PATH = '/api/v1/svc/document_loader/data_sources';

const listDataSources = createAsyncThunk(
  'corpus/listDataSources',
  async ({ brandId, params = {} } = {}, { rejectWithValue }) => {
    try {
      const query = {
        brand_id: brandId,
        page: params.page ?? 1,
        limit: params.limit ?? 10,
        search: params.search,
        sort: params.sort,
        learning_document: true,
      };
      const response = await AspApi.get(BASE_PATH, {
        params: query,
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data ||
          error?.message ||
          'Unable to fetch data sources',
      );
    }
  },
);

const showDataSource = createAsyncThunk(
  'corpus/showDataSource',
  async ({ id, brandId } = {}, { rejectWithValue }) => {
    try {
      const response = await AspApi.get(`${BASE_PATH}/${id}`, {
        params: {
          brand_id: brandId,
          learning_document: true,
        },
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data ||
          error?.message ||
          'Unable to fetch datasource details',
      );
    }
  },
);

const createDataSource = createAsyncThunk(
  'corpus/createDataSource',
  async ({ data, brandId } = {}, { rejectWithValue }) => {
    try {
      const response = await AspApi.post(BASE_PATH, data, {
        params: {
          brand_id: brandId,
          learning_document: true,
        },
      });
      if (response.status != 200) {
        return rejectWithValue(
          response?.response?.data?.error ||
            response?.message ||
            'Unable to create datasource',
        );
      }
      return response?.data;
    } catch (error) {
      const message =
        error?.response?.data ||
        error?.message ||
        'Unable to create datasource';

      console.error('createDataSource failed:', message, error);
      return rejectWithValue(message);
    }
  },
);

const deleteDataSource = createAsyncThunk(
  'corpus/deleteDataSource',
  async ({ id, brandId } = {}, { rejectWithValue }) => {
    try {
      const res = await AspApi.delete(`${BASE_PATH}/${id}`, {
        params: {
          brand_id: brandId,
          learning_document: true,
        },
      });
      if (res?.status != 200) {
        return rejectWithValue(id);
      }
      return id;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data ||
          error?.message ||
          'Unable to delete datasource',
      );
    }
  },
);

const usageMetrics = createAsyncThunk(
  'corpus/usageMetrics',
  async ({ brandId } = {}, { rejectWithValue }) => {
    try {
      const response = await AspApi.get(
        `/api/v1/svc/document_loader/metric/usage_metrics`,
        {
          params: {
            brand_id: brandId,
          },
        },
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data ||
          error?.message ||
          'Unable to fetch usage metrics',
      );
    }
  },
);

const showLearningDocument = createAsyncThunk(
  'corpus/showLearningDocument',
  async ({ brandId } = {}, { rejectWithValue }) => {
    try {
      const response = await AspApi.get(`${BASE_PATH}/learning_document`, {
        params: {
          brand_id: brandId,
        },
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data ||
          error?.message ||
          'Unable to fetch learning document',
      );
    }
  },
);

export {
  listDataSources,
  showDataSource,
  createDataSource,
  deleteDataSource,
  usageMetrics,
  showLearningDocument,
};
